import { $emit as i } from "../utils/gogocodeTransfer.js";
import { ElSlider as s } from "element-plus";
import { resolveComponent as a, openBlock as m, createElementBlock as u, normalizeClass as d, createVNode as p } from "vue";
import { _ as c } from "../_plugin-vue_export-helper-dad06003.js";
const f = {
  name: "rSlider",
  props: {
    /**
     * 属性介绍
     */
    color: {
      type: String,
      default: "gray"
    },
    /**
     * 是否显示tooltip
     */
    showTooltip: {
      type: Boolean,
      default: !1
    },
    /**
     * 绑定值
     */
    value: {
      type: Number,
      default: 0
    }
  },
  components: {
    Slider: s
  },
  computed: {
    isGreen() {
      return this.color === "green";
    },
    isRed() {
      return this.color === "red";
    }
  },
  data() {
    return {
      numbeMarks: {
        0: "0%",
        25: "25%",
        50: "50%",
        75: "75%",
        100: "100%"
      }
    };
  },
  methods: {
    input(e) {
      i(this, "input", e);
    },
    formatTooltip(e) {
      return `${e}%`;
    }
  },
  emits: [
    {
      /**
       * 同 element 的 Slider
       */
      input: null
    },
    "update:value"
  ]
};
function _(e, v, o, h, l, r) {
  const n = a("Slider", !0);
  return m(), u(
    "div",
    {
      class: d(["r-slider", {
        "green-slider": r.isGreen,
        "red-slider": r.isRed
      }])
    },
    [
      p(n, {
        "show-tooltip": o.showTooltip,
        min: 0,
        "model-value": o.value,
        onInput: r.input,
        "format-tooltip": r.formatTooltip,
        marks: l.numbeMarks
      }, null, 8, ["show-tooltip", "model-value", "onInput", "format-tooltip", "marks"])
    ],
    2
    /* CLASS */
  );
}
const t = /* @__PURE__ */ c(f, [["render", _], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/slider/slider.vue"]]);
t.install = function(e) {
  e.component(t.name, t);
};
export {
  t as default
};
